/** EXPORTUL UNUI MODUL, oricare ar fi formatul — ce au în comun editorul și
 *  colecția: codul formatului se încarcă la cerere, iar omul vede că se
 *  întâmplă ceva.
 *
 *  TOASTUL DE «SE PREGĂTEȘTE». Un DWG ține câteva secunde: desenul se
 *  compune, pleacă la server, se scrie, se convertește și abia apoi
 *  browserul arată descărcarea. În tot timpul ăsta ecranul nu se schimbă cu
 *  nimic, iar un buton apăsat fără urmare se apasă a doua oară. Deci la
 *  pornire apare un toast, care se stinge când fișierul a plecat spre
 *  descărcări și e înlocuit de confirmare; la eșec se stinge și rămâne
 *  eroarea ecranului. */
import type * as api from "../../../api";
import { t } from "../../../i18n";
import { arata, inchide } from "../../../toasts";
import type { TronsonDoc } from "../doc";
import type { FormatExport } from "./MeniuExport";

/** Planșa modulului, în formatul cerut, ca fișier descărcat. Aruncă dacă n-a
 *  mers — cine cheamă scrie eroarea pe ecranul lui. */
export async function exportaTronson(format: FormatExport, doc: TronsonDoc,
                                     meta: api.Tronson | null): Promise<void> {
  const nume = format.toUpperCase();
  const pornit = arata(t("export.pornit", { format: nume, cod: doc.id }), "info");
  try {
    if (format === "pdf") {
      const { exportaTronsonPdf } = await import("./pdf");
      await exportaTronsonPdf(doc, meta);
    } else {
      const { exportaTronsonDwg } = await import("./dwg");
      const raport = await exportaTronsonDwg(doc);
      if (raport && raport.pierdute) {
        arata(t("export.dwg_pierdute", { n: raport.pierdute,
                                         din: raport.entitati_dxf ?? 0 }), "info");
      }
    }
    arata(t("export.gata", { format: nume, cod: doc.id }), "info");
  } finally {
    inchide(pornit);
  }
}
